import { AnalysisProseCard } from '../../../components';
import { useTranslation } from 'react-i18next';

interface KeyInsightProps {
  text?: string;
  staggerStart?: number;
}

export const KeyInsight = ({ text, staggerStart }: KeyInsightProps) => {
  const { t } = useTranslation('analysis');

  if (!text) return null;

  return (
    <AnalysisProseCard
      title={t('analysisResult.keyInsight.keyInsight')}
      description={text}
      descriptionVariant="statement"
      columns={1}
      staggerStart={staggerStart ?? 0}
    />
  );
};
